import type { IconProps } from '@/ui/Icons/IconProps';

export const GreenGasIcon = (props: IconProps) => (
  <svg
    className={props.className}
    height={props.height ?? 125}
    width={props.width ?? 126}
    style={props.style}
    viewBox="0 0 126 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.04" filter="url(#filter0_d_3926_83048)">
      <circle cx="63" cy="61.375" r="59" fill="url(#paint0_linear_3926_83048)" />
      <circle cx="63" cy="61.375" r="58.5" stroke="#39A150" />
    </g>
    <g opacity="0.08" filter="url(#filter1_d_3926_83048)">
      <circle cx="63" cy="61.375" r="47" fill="url(#paint1_linear_3926_83048)" />
      <circle cx="63" cy="61.375" r="46.5" stroke="#39A150" />
    </g>
    <g filter="url(#filter2_ddii_3926_83048)">
      <rect x="34" y="31.375" width="60" height="60" rx="30" fill="white" />
      <rect x="34" y="31.375" width="60" height="60" rx="30" fill="#00CB20" fillOpacity="0.06" />
      <rect
        x="34"
        y="31.375"
        width="60"
        height="60"
        rx="30"
        fill="url(#paint2_linear_3926_83048)"
      />
    </g>
    <g filter="url(#filter3_i_3926_83048)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.8387 47C66.4722 47.0026 67.0165 47.4506 67.1407 48.0718C67.7433 51.085 69.5677 54.0134 71.9995 55.9588C74.9047 58.283 76.4989 61.1707 76.4999 64.3302V64.3333L76.4999 64.3278L76.4999 64.3302C76.5082 66.4365 75.8911 68.4978 74.7268 70.2531C73.562 72.0091 71.9022 73.3797 69.9576 74.1911C68.013 75.0026 65.8712 75.2184 63.8038 74.8112C61.7364 74.404 59.8365 73.3922 58.3448 71.9039C57.8236 71.3838 57.8226 70.5395 58.3427 70.0182C58.8628 69.497 59.7071 69.496 60.2283 70.0161C61.3461 71.1314 62.7699 71.8897 64.3192 72.1948C65.8684 72.5 67.4734 72.3383 68.9306 71.7302C70.3878 71.1221 71.6317 70.095 72.5045 68.7791C73.3773 67.4632 73.8398 65.9179 73.8333 64.3388L73.8333 64.3333C73.8333 62.1608 72.7608 59.9829 70.3337 58.0412C68.4699 56.5501 66.9055 54.5843 65.8313 52.4006C65.5932 52.884 65.3303 53.3558 65.0435 53.814C64.6528 54.4382 63.8301 54.6276 63.2059 54.2369C62.5817 53.8462 62.3924 53.0235 62.783 52.3993C63.6165 51.0677 64.2072 49.5989 64.528 48.0611C64.6574 47.4409 65.2052 46.9974 65.8387 47ZM56.4999 50.04C57.1355 50.04 57.6827 50.4886 57.8074 51.1118C58.1305 52.7275 59.1042 54.2996 60.3961 55.3535C62.1542 56.7878 63.1666 58.608 63.1666 60.64C63.1666 64.3191 60.1868 67.3733 56.4999 67.3733C52.813 67.3733 49.8333 64.3191 49.8333 60.64C49.8333 58.6319 50.8228 56.7782 52.6137 55.3455C53.9032 54.3139 54.8676 52.7361 55.1925 51.1118C55.3171 50.4886 55.8643 50.04 56.4999 50.04ZM56.5041 54.9003C55.9061 55.8659 55.1497 56.7317 54.2795 57.4278C53.0037 58.4484 52.4999 59.5814 52.4999 60.64C52.4999 62.8809 54.3201 64.7067 56.4999 64.7067C58.6797 64.7067 60.4999 62.8809 60.4999 60.64C60.4999 59.5787 59.9923 58.4656 58.7104 57.4198C57.8552 56.7222 57.1025 55.8613 56.5041 54.9003Z"
        fill="url(#paint3_linear_3926_83048)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3926_83048"
        x="0.756757"
        y="0.212838"
        width="124.486"
        height="124.486"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3926_83048" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3926_83048"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_3926_83048"
        x="12.7568"
        y="12.2128"
        width="100.486"
        height="100.486"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3926_83048" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3926_83048"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_ddii_3926_83048"
        x="27.5714"
        y="27.0893"
        width="72.8571"
        height="72.8571"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.14286" />
        <feGaussianBlur stdDeviation="3.21429" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3926_83048" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3926_83048"
          result="effect2_dropShadow_3926_83048"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_3926_83048"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2.14286" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="shape" result="effect3_innerShadow_3926_83048" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1.08108" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          mode="normal"
          in2="effect3_innerShadow_3926_83048"
          result="effect4_innerShadow_3926_83048"
        />
      </filter>
      <filter
        id="filter3_i_3926_83048"
        x="49.8333"
        y="47"
        width="26.6667"
        height="28.0117"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1.33333" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_3926_83048" />
      </filter>
      <linearGradient
        id="paint0_linear_3926_83048"
        x1="63"
        y1="2.375"
        x2="63"
        y2="120.375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#59B56D" />
        <stop offset="1" stopColor="#2CA046" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3926_83048"
        x1="63"
        y1="14.375"
        x2="63"
        y2="108.375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#59B56D" />
        <stop offset="1" stopColor="#2CA046" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3926_83048"
        x1="64"
        y1="18.875"
        x2="64"
        y2="98.875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009658" />
        <stop offset="1" stopColor="#00B96D" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3926_83048"
        x1="76.8056"
        y1="42.5817"
        x2="58.5034"
        y2="76.6255"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);
